import React, { memo, useCallback, useEffect, useState } from 'react';
import { IContentDetail } from 'src/interface';
import { AdUtils } from 'src/utils';
import { getWithPath } from 'src/utils/http';
import { Element } from 'src/components';
import { AdBanner } from 'src/modules/shared/components/ad';

interface IProps {
    ad: any;
    content?: IContentDetail;
}

interface IState {
    fetched?: boolean;
    zoneAdaptive?: string;
    elId?: string;
    zoneId: string;
    topicId?: any;
    adtimaConfig?: any;
}

export function AdMastheadPopup({ content, ad = {} }: IProps) {
    const [state, setState] = useState<IState>();
    const [canRender, setCanRender] = useState<boolean>(false);
    const fetchFn = () => {
        return getWithPath(ad.masthead.url || '', ad.masthead.params || {});
    };

    useEffect(() => {
        const masthead = ad.masthead || {};
        if (!masthead.fetched && !masthead.zoneAdaptive) {
            fetchFn().then((resp: any) => {
                if (resp && resp.data) {
                    setState(resp.data);
                }
            });
        } else {
            setState(ad.masthead as IState);
        }
    }, [ad.masthead]);

    useEffect(() => {
        if (state) {
            setTimeout(() => {
                const _window: any = window;
                _window.adtimaBMConfig = {
                    ..._window.adtimaBMConfig,
                    ...state.adtimaConfig,
                };
                if (state.zoneAdaptive) {
                    const zoneAdaptive = {
                        [state.zoneId || '']: state.zoneAdaptive,
                    };
                    _window.adtimaBMConfig = {
                        ..._window.adtimaBMConfig,
                        zoneAdaptive: zoneAdaptive,
                    };
                }

                _window.categoryShortUrl = content?.category?.shortUrl;
                _window.cate_path =
                    content?.category?.shortUrl || _window.cate_path;
                _window.article_id = content?.contentId || _window.article_id;
                //test
                let topidIds = state.topicId || '';
                if (
                    /the-gioi|xa-hoi|thoi-su|giao-thong|moi-truong|van-hoa|nghe-thuat|am-thuc/.test(
                        _window.cate_path
                    )
                ) {
                    _window.adtimaTopicIds = [
                        topidIds,
                        'BM_Wap_testing1701',
                        _window._BM.customTopic,
                    ];
                } else {
                    _window.adtimaTopicIds = [
                        topidIds,
                        _window._BM.customTopic,
                    ];
                }
                const params = {
                    pageType: 'contentdetail',
                    popup: true,
                    noAds: content?.isNoAd,
                };
                AdUtils.preloadAd(params);
            }, 50); // delay set adtimaConfig
            setCanRender(true);
        }
    }, [state]);

    const renderAds = useCallback(() => {
        if (!state || content?.isNoAd || !canRender) {
            return null;
        }

        return (
            <Element id="js-masthead">
                {state.zoneAdaptive && (
                    <AdBanner
                        elId={state.elId || ''}
                        classNameContainer={'masthead-wrapper'}
                        zoneAdaptive={state.zoneAdaptive}
                    />
                )}
            </Element>
        );
    }, [canRender, content, state]);

    return <>{renderAds()}</>;
}

export default memo(AdMastheadPopup);
